module.exports = __webpack_public_path__ + "static/Spain-Step4-9586581e35e46717e5a66b38aafd242d.png";